<ng-container *ngIf="vo$ | async; let vo">
	<a [href]="vo.to" target="_blank">
		<mat-icon *ngIf="vo.withIcon" [svgIcon]="CoreIcons.Doc"></mat-icon>
		<ng-content></ng-content>
	</a>
</ng-container>
